import { z } from "zod";

export const relationSchema = z.object({
  id: z.number(),
  name: z.string(),
  status: z.boolean().default(true),
  max_order_time: z.string().optional().nullable(),
  street: z.string().optional().nullable(),
  house_number: z.string().optional().nullable().nullable(),
  house_number_addition: z.string().optional().nullable(),
  postal_code: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  country: z.string().optional().nullable(),
  phone: z.string().optional().nullable(),
  sticker_amount: z.number().optional().nullable(),
  tireset_sticker_config: z.array(z.string()).optional().nullable(),
  qrFieldOptions: z.array(z.string()).optional().nullable(),
  dbb_api_identifier: z.string().optional().nullable(),
  invoice_type: z.string().optional().nullable(),
  debtor_number: z.string().optional().nullable(),
  invoice_product: z.string().optional().nullable(),
  invoice_cleaning: z.boolean().optional().nullable(),
  only_freestock: z.boolean().optional().nullable(),
});

export type RelationModel = z.infer<typeof relationSchema>;
